module.exports = __webpack_public_path__ + "cc9c77e0e0f9dbfb6417b1d7d17cdce6.png";